import { useEffect, useState } from "react";
import { GeneralController } from "../../../controllers/generalController";
import { CollaborationController } from "../../../controllers/collaborationController";
import { ReservationSettingsController } from "../../../controllers/reservationSettingsController";
import { ApiUtil } from "../../../util/apiUtil";
import { useToastPromise } from "../../../components/toastPromise";
import { TableName } from "../../../constants/tableName";
import { ReservationsController } from "../../../controllers/reservationsController";
import { DateUtil } from "../../../util/dateUtil";
import { TableList } from "../../../components/tableList";
import "../../../assets/css/reports.css";
import { TableListPreview } from "../../../components/tableListPreview";
import { Textbox } from "../../../components/textbox";

export const NormalReservationReport = () => {
  const toastPromise = useToastPromise();
  const initialReservationReport = {
    reservationDate: DateUtil.toYYYYMMDDFormat(new Date()),
    timeSlot: {},
    users: [],
    maxPax: 0,
    currentPax: 0,
    availablePax: 0,
  };
  const [loading, setLoading] = useState(false);
  const [collaboration, setCollaboration] = useState({});
  const [reservationSettings, setReservationSettings] = useState({});
  const [normalReservations, setNormalReservations] = useState([]);
  const [reservationReportsList, setReservationReportsList] = useState([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const handlePreviewPopupDialogOpen = (content = null) => {
    setSelectedData(content);
    setIsPreviewOpen(true);
  };
  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
  };
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        GeneralController.getAll({ resolve: resolve, reject: reject });
      }),
      successMessage: (data) => {
        const generalData = ApiUtil.deserialize({ data: data });
        if (generalData[0]?.existingCollaboration) {
          Promise.all([
            getCollaboration(generalData[0].existingCollaboration),
            getReservationSetting(generalData[0].existingCollaboration),
          ]).then(([cd, rsd]) => {
            const collaborationData = ApiUtil.deserialize({ data: cd });
            setCollaboration(collaborationData);
            const reservationSettingData = ApiUtil.deserialize({ data: rsd });
            setReservationSettings(reservationSettingData[0]);
            getReservations(reservationSettingData[0].id)
              .then((rd) => {
                const reservationsData = ApiUtil.deserialize({ data: rd });
                setNormalReservations(reservationsData);
              })
              .finally(() => setLoading(false));
          });
        }
        return "Reservations reports retrieved successfully.";
      },
      errorMessage: (data) => data,
    });
  };
  const getCollaboration = (collaborationId) => {
    return new Promise((resolve, reject) => {
      CollaborationController.get({
        collaborationId: collaborationId,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const getReservationSetting = (collaborationId) => {
    return new Promise((resolve, reject) => {
      ReservationSettingsController.get({
        collaborationId: collaborationId,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const getReservations = (reservationSettingsId) => {
    return new Promise((resolve, reject) => {
      ReservationsController.get({
        reservationSettingsId: reservationSettingsId,
        type: TableName.NORMALRESERVATIONS,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const groupReservation = () => {
    const dateList = [];
    let currentDate = new Date(collaboration.startDate);
    while (currentDate <= new Date(collaboration.endDate)) {
      reservationSettings?.normalSettings?.timeSlotsList?.forEach(
        (timeSlot) => {
          const reservationDate = DateUtil.toYYYYMMDDFormat(
            new Date(currentDate)
          );
          const { currentPax, userList } = getCurrentReservation(
            timeSlot.id,
            reservationDate
          );
          dateList.push({
            ...initialReservationReport,
            reservationDate: reservationDate,
            timeSlot: timeSlot,
            users: userList.map((userId) => ({ id: userId })),
            maxPax: timeSlot.maxPax,
            currentPax: currentPax,
            availablePax: timeSlot.maxPax - currentPax,
          });
        }
      );
      currentDate.setDate(currentDate.getDate() + 1);
    }
    setReservationReportsList(dateList);
  };
  const getCurrentReservation = (timeSlotId, reservationDate) => {
    let currentPax = 0;
    let userList = [];
    const filteredSlots = normalReservations.filter(
      (data) =>
        data.timeSlot.id === timeSlotId &&
        data.reservationDate === reservationDate &&
        data.status === "active"
    );
    filteredSlots.forEach((data) => {
      if (!userList.includes(data.userId)) userList.push(data.userId);
      currentPax += data.pax;
    });
    return { currentPax, userList: [...userList] };
  };
  useEffect(() => {
    getAll();
  }, []);
  useEffect(() => {
    if (!loading) groupReservation();
  }, [loading]);

  return (
    <section id="normalReservationReport">
      <h4>NORMAL RESERVATION REPORT</h4>
      <hr />
      <Textbox
        type="text"
        name="collaborationId"
        value={collaboration.id}
        placeholder="Collaboration ID"
        readOnly={true}
      />
      <Textbox
        type="text"
        name="reservationSettingsId"
        value={reservationSettings.id}
        placeholder="Reservation Settings ID"
        readOnly={true}
      />
      <Textbox
        type="text"
        name="title"
        value={collaboration.title}
        placeholder="Title"
        readOnly={true}
      />
      <Textbox
        type="text"
        name="startDate"
        value={collaboration.startDate}
        placeholder="Start Date"
        readOnly={true}
      />
      <Textbox
        type="text"
        name="endDate"
        value={collaboration.endDate}
        placeholder="End Date"
        readOnly={true}
      />
      <hr />
      <TableList
        isEditable={false}
        loading={loading}
        list={reservationReportsList}
        handlePopupDialogOpen={() => {}}
        handlePreviewPopupDialogOpen={handlePreviewPopupDialogOpen}
        rowsPerPage={reservationSettings?.normalSettings?.timeSlotsList?.length}
      />
      <TableListPreview
        loading={loading}
        isPreviewOpen={isPreviewOpen}
        handlePreviewClose={handlePreviewClose}
        content={selectedData}
      />
    </section>
  );
};
